<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'StakingManage'
    };
</script>

<style lang="less" scoped>
</style>
